import { makeStyles, Theme, createStyles } from '@material-ui/core';
import { PrimaryTextButton } from 'src/components/ui/Buttons';
import { grey, primaryGreen } from 'src/data/colors';

export const AVAILABLE_TAGS = {
  tags: 'tags',
  views: 'views',
} as const;

const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    buttonsContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-end',
      height: 'fit-content',
    },
    tagToggle: {
      backgroundColor: 'white',
      border: '1px solid #e0e0e0',
    },
    viewsToggle: {
      backgroundColor: 'white',
      border: '1px solid #e0e0e0',
    },
    toggleSelected: {
      borderBottom: `2px solid ${primaryGreen}`,
    },
  })
);

interface TagsTabsProps {
  selectedTab: typeof AVAILABLE_TAGS.tags | typeof AVAILABLE_TAGS.views;
  setSelectedTab: (tab: typeof AVAILABLE_TAGS.tags | typeof AVAILABLE_TAGS.views) => void;
  showViews: boolean;
}

const TagsTabs = ({ selectedTab, setSelectedTab, showViews }: TagsTabsProps) => {
  const classes = useStyles();
  return (
    <div className={classes.buttonsContainer}>
      {showViews && (
        <div className={`${selectedTab === AVAILABLE_TAGS.views && classes.toggleSelected}`}>
          <PrimaryTextButton
            onClick={() => {
              setSelectedTab(AVAILABLE_TAGS.views);
            }}
            style={{
              color: selectedTab === AVAILABLE_TAGS.views ? '' : grey,
            }}
          >
            Views
          </PrimaryTextButton>
        </div>
      )}
      <div className={`${selectedTab === AVAILABLE_TAGS.tags && classes.toggleSelected}`}>
        <PrimaryTextButton
          onClick={() => {
            setSelectedTab(AVAILABLE_TAGS.tags);
          }}
          style={{
            color: selectedTab === AVAILABLE_TAGS.tags ? '' : grey,
          }}
        >
          Tags
        </PrimaryTextButton>
      </div>
    </div>
  );
};

export default TagsTabs;
